var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUploadDockCloud(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "upload-cloud",
    clipPath: "url(#clip0_15136_132366)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M13.3326 13.6672L9.99923 10.3339M9.99923 10.3339L6.6659 13.6672M9.99923 10.3339V17.8339M16.9909 15.6589C17.8037 15.2158 18.4458 14.5146 18.8158 13.6661C19.1858 12.8175 19.2627 11.8699 19.0344 10.9728C18.8061 10.0757 18.2855 9.28015 17.5548 8.71176C16.8241 8.14337 15.925 7.8345 14.9992 7.83389H13.9492C13.697 6.85826 13.2269 5.9525 12.5742 5.18472C11.9215 4.41693 11.1033 3.8071 10.181 3.40106C9.2587 2.99503 8.25636 2.80336 7.24933 2.84046C6.2423 2.87756 5.25679 3.14247 4.36688 3.61528C3.47697 4.08808 2.70583 4.75648 2.11142 5.57021C1.51701 6.38394 1.11481 7.32184 0.935051 8.31338C0.755293 9.30493 0.802655 10.3243 1.07358 11.2949C1.3445 12.2655 1.83194 13.1621 2.49923 13.9172",
    stroke: "#0C66E4",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_15136_132366"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0 0.333984)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadDockCloud);
export default __webpack_public_path__ + "static/media/uploadDockCloud.178dcf34abf9f764070d3f4d9f4faac0.svg";
export { ForwardRef as ReactComponent };